import script from "./DiscoverControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscoverControl.vue?vue&type=script&setup=true&lang=ts"

import "./DiscoverControl.vue?vue&type=style&index=0&id=27bf5e63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27bf5e63"]])

export default __exports__